import Filter from "../filter";
import Price from "../filter-price";
import FiltersResume from "../filters-resume";
import PaginationAutoLoading from "../pagination-auto-loading";
import CancelablePromise from "../cancelable-promise";
import PageLoadAnimation from "../page-load-animation";
import SortManager from "../sort";

class FiltersManager {
    constructor() {
        this._init()
    }
    _init() {
        this.el = document.querySelector('[data-filters]')
        if(!this.el) {
            return;
        }
        this.promise = null
        this.elFetch = document.querySelector('[data-fetch-action]')

        this.params = new URLSearchParams(window.location.search)
        this.autoLoader = new PaginationAutoLoading(this)

        let types = ['size[]', 'color[]', 'brand[]']
        this.filters = []

		this.resume = new FiltersResume(this)

        types.forEach(type => {
            this.filters.push(new Filter(type, this))
        })
        
        this.price = new Price(this)
        this.sort = new SortManager(this)

        this.loading = new PageLoadAnimation(false)
    }
    updateParams(newParams, isPrice = false) {
        this.params = newParams

        this.updateURL()
        this.autoLoader.update()
        this.sort.update()

        this.manage()

        this.updateFilters(isPrice)
    }
    updateURL(isPaginator = false) {
        if(!isPaginator) {
            this.params.delete('page')
            this.params.delete('view')
        }
        this.params.sort()
        window.history.replaceState({}, '', `${location.pathname}?${this.params}`)
    }
    updateFilters(isPrice) {
        this.resume.updateList(this.params)    
        this.filters.forEach(filter => filter.updateSelection())
        if(!isPrice) {
            this.price.filterManager.updateFromManager()
        }
    }
    manage() {
        if(window.location.href.includes("?"))
		{
            this.autoLoader.setButtons(false)

			if(this.timeout) {
				clearTimeout(this.timeout)
			}

			if(this.promise) {
				this.promise.cancel()
				this.promise = null
            }

			this.timeout = setTimeout(() => {
                this.loading.toggleLoading(true)
				this.promise = new CancelablePromise(fetch(window.location.href + "&type=partial"))
				this.promise.run()
					.then((data) => data.text())
					.then((data) => {
                        this.elFetch.innerHTML = data
                        this.autoLoader.update()
                        this.promise = null
                    })
                    .finally(() => this.loading.toggleLoading(false))
			}, 1000)
		}
    }
}

export default FiltersManager